import { connect } from "react-redux";
import PropTypes from "prop-types";
import LargePrimaryNavigation from "../LargePrimaryNavigation";
import { LARGE_VIEWPORT, FEMALE, MALE } from "../../../state/modules/layout";
import { getIsNavApiLoaded } from "../../../state/modules/navigation";
import withViewport from "../../Viewport/withViewport";
import SSRHydrationWrapper from "../SSRHydrationWrapper";
import styles from "./index.css";

const ID = "primarynav";

const LargeNavigation = ({ isNavApiLoaded }) => (
  <SSRHydrationWrapper isNavApiLoaded={isNavApiLoaded}>
    <div className={styles.largeNavigation} data-testid={ID} id={ID}>
      <LargePrimaryNavigation forGender={FEMALE} viewable={[LARGE_VIEWPORT]} />
      <LargePrimaryNavigation forGender={MALE} viewable={[LARGE_VIEWPORT]} />
    </div>
  </SSRHydrationWrapper>
);

LargeNavigation.propTypes = {
  isNavApiLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isNavApiLoaded: getIsNavApiLoaded(state)
});

export default connect(mapStateToProps)(withViewport(LargeNavigation));
